import React from "react";

import { Box, Card, CardContent, Link, Typography } from "@mui/material";

import { SALES_EMAIL } from "helpers/constants";

export const NeedHelp: React.FC = () => {
  return (
    <Card>
      <CardContent>
        <Box paddingY={1} display="flex" flexDirection="column" gap="24px">
          <Typography variant="h4">Need Help?</Typography>
          <Typography variant="body1" component="p">
            <Link
              href={`mailto:${SALES_EMAIL}?subject=Assay Marketplace Catalog Support`}
              target="_blank"
              variant="body1"
              color="secondary"
              underline="always"
            >
              Email us
            </Link>{" "}
            a question.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
